import { Box, Button, Paper } from '@mui/material'
import useErrorLog from './hooks/useErrorLog'
import React from 'react'
import Loading from './components/common/Loading';

type ErrorFallbackProps = {
    error: Error;
    resetErrorBoundary: (reset: boolean) => void;
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
    const loading = useErrorLog(error)
    return (
        <Paper
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100%'
            }}
        >
            {
                loading ?
                <Loading /> :
                <>
                    <h2>Something went wrong:</h2>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                        <Button variant="outlined" color={'inherit'} onClick={() => resetErrorBoundary(true)}>Reset</Button>
                        <Button variant="outlined" color={'inherit'} onClick={() => resetErrorBoundary(false)}>Try
                            Again</Button>
                    </Box>
                </>
            }
        </Paper>
    )
}

export default ErrorFallback